/**
 * Created by intellicar-rinas on 8/1/18.
 */
import React, {Component} from 'react';
import './TPMSView.css';
import {dateFormat} from '../../../../constants/constants';
import moment from 'moment';
import ReportAPIs from '../../../../APIs/ReportAPIs';
import InGraph from '../../../ReportWindow/schema/InGraph/InGraph2'
import axios from 'axios';

const generateTires =()=> {
    let tires = 14;
    let arr = [];
    for(let tyreid=1; tyreid<=tires; tyreid++) {
        arr.push({
            id: tyreid,
            name: 'Tire ' + tyreid,
            rightAlign: tyreid % 2 === 0,

        })
    }
    return arr;
};

const oneDay = 1000 * 60 * 60 * 24;

class BridgeStoneTruck extends  Component {

    historyButtons = [
        {id:5, name:'4w', time:24 * oneDay},
        {id:4, name:'2w', time:12 * oneDay},
        {id:3, name:'1w', time:7 * oneDay},
        {id:2, name:'4d', time:4 * oneDay},
        {id:1, name:'2d', time:2 * oneDay},
        {id:0, name:'1d', time:oneDay},
    ];

    state = {
        tires: generateTires(),
        vehicle:{
            stats:{},
            vehiclemeta:{}
        },
        selectedHistoryButton:this.historyButtons[4]
    };

    constructor() {
        super();

        this.updateView =()=> {
            if(this.props && this.props.vehicle) {
                let vehicle = this.props.vehicle();
                if(this.vehicleid !== vehicle.vehicleid) {
                    this.reset();
                    this.vehicleid = vehicle.vehicleid;
                }
                this.setState({vehicle});
                setTimeout(()=>{
                    this.setState({vehicle});
                    // this.forceUpdate();
                }, 100);
            }
            this.forceUpdate();
            this.getData();
        };

        this.reset =(callback=e=>{})=> {
            this.clearState(callback);
        };

        this.clearState =(callback=e=>{})=> {
            this.setState({stats:{}, vehicle:{}, selectedTire:null}, callback);
        };

        this.getTime =()=> {
            return this.state.vehicle && this.state.vehicle.stats && moment(this.state.vehicle.stats.time).format(dateFormat);
        };

        this.get =key=> {
            if(!this.state.vehicle) return null;

            if(this.state.vehicle.can2 && key in this.state.vehicle.can2) {
                return this.state.vehicle.can2[key]
            }
            if(this.state.data && key in this.state.data) {
                return this.state.data[key]
            }
            if(this.state.vehicle && key in this.state.vehicle) {
                return this.state.vehicle[key];
            }
            if(this.state.vehicle.stats && key in this.state.vehicle.stats) {
                return this.state.vehicle.stats[key];
            }
            if(this.state.vehicle.vehiclemeta && key in this.state.vehicle.vehiclemeta) {
                return this.state.vehicle.vehiclemeta[key]
            }
            if(this.state.vehicle && key in this.state.vehicle) {
                return this.state.vehicle[key]
            }
        };

        this.getData = () => {

            if(!this.props.vehicle)
                return;

            // Fire for update
        };

        this.onTireClick =tire=> {
            this.setState({selectedTire: tire}, ()=>{
                this.getHistory(this.state.selectedHistoryButton);
            });
        };



        this.getAxils =()=> {
            return (this.state.vehicle ? this.state.vehicle.tpmsconfig : []) || []
        };

        this.getTirePressureStatus =tire=> {
            tire.idealpsi = parseFloat(tire.idealpsi, 10);
            if(tire.pressure > tire.idealpsi + 10) {
                return ' -red';
            } else if(tire.pressure < tire.idealpsi - 10) {
                return ' -blue';
            }
            return '';
        };

        this.getTire =(tire, index)=> {
            return (
                <div className={"bstcba-tire" + (tire.enabled ? ' -enabled':'') + (this.getTirePressureStatus(tire)) + (tire.tyreid === this.getSelectedTire().tyreid ? ' -selected':'')}
                     key={index} onClick={()=>this.onTireClick(tire)}>
                    {tire.tyreid}
                    {
                        tire.enabled ? (
                            <div className="bstcbat-data">
                                <div className="bstcbatd-top">{parseInt(tire.pressure, 10)} psi</div>
                                <div className="bstcbatd-bottom">{parseInt(tire.temperature, 10)} °C</div>
                            </div>
                        ) : ''
                    }
                </div>
            )
        };

        this.getAxil =(axil, index)=> {
            return (
                <div className="bstcb-axil" key={index}>
                    <div className="bstcba-body"></div>
                    <div className={"bstcba-tireset" + (axil.left.length > 2 ? ' -multiple': '')}>{
                        axil.left.map((tire, index2)=> {
                            return this.getTire(tire, index2)
                        })
                    }</div>
                    <div className={"bstcba-tireset -right" + (axil.right.length > 2 ? ' -multiple': '')}>{
                        axil.right.map((tire, index2)=> {
                            return this.getTire(tire, index2)
                        })
                    }</div>
                </div>
            )
        };

        this.getSelectedTire =()=> {
            return this.state.selectedTire || {}
        };


        this.toggleSimulation =()=> {
            if(!this.state.simulating && window.startMQTTSimulation) {
                window.startMQTTSimulation();
                this.setState({simulating: true})
            } else if(this.state.simulating && window.stopMQTTSimulation) {
                window.stopMQTTSimulation();
                this.setState({simulating: false})
            }
        };


        const parseData =(resp, key)=> {
            let arr = [];
            for(let idx in resp) {
                arr.push({time:resp[idx].time, value: resp[idx][key]})
            }
            return arr;
        };


        this.drawGraph =(reqTime = Date.now())=> {
            if(!this.graphData || !this.state.selectedTire)
                return;

            let tire = this.getSelectedTire();
            let data1 = this.graphData[0][this.getSelectedTire().tyreid];
            let data2 = this.graphData[1];
            if(data2.length === 0) {
                data2 = [{value:0, time:Date.now() + (1000 * 60 * 60)}];
            }
            if(data1) {
                for(let idx in this.graph.config) {
                    let parsedData = parseData(data1, this.graph.config[idx].key);
                    if(parseInt(idx) == 2) {
                        parsedData = data2 || [];
                    }
                    this.graph.ref.draw({
                        data:[parsedData],
                        axis: parseInt(idx),
                        reqTime,
                        priority: 1
                    }, {
                        xDomainValue: [this.starttime, this.endtime],
                        shapes: [{
                            strokeOpacity: 0.3,
                            stroke: '#fff',
                            axis:0,
                            type: 'path',
                            data: [
                                {time:this.starttime, value:tire.idealpsi},
                                {time:this.endtime, value:tire.idealpsi},
                            ]
                        }]
                    });

                }

            } else {
                console.log('There is no data for selected Tyre');
            }
        };


        this.getHistory =(button)=> {

            if(button.id === this.state.selectedHistoryButton.id && this.graphData) {
                this.drawGraph();
                return;
            }

            this.setState({selectedHistoryButton: button});

            if(this.state.historyBusy)
                return;

            this.starttime = Date.now() - button.time;
            this.endtime = Date.now();
            let reqTime = Date.now();

            let body = {
                starttime: this.starttime,
                endtime: this.endtime,
                vehicleid: this.get('vehicleid'),
                bucketPeriod: 60
            };

            this.setState({historyBusy: true});

            const handleSuccess =resp=> {
                this.setState({historyBusy: false});
                this.graphData = resp;
                this.drawGraph(reqTime);

            };

            const handleFailure =resp=> {
                this.setState({historyBusy: false});
            };

            axios.all([ReportAPIs.getTPMSHistory(body), ReportAPIs.getMileage(body)])
                .then(handleSuccess, handleFailure);
        };

        this.setRef = (tool, ref) =>{
            tool.ref = ref && ref.wrappedInstance ? ref.wrappedInstance : ref;
        };


        this.getGraphConfig = (tool) => {
            return {
                width: 380,
                height: 160,
                type: tool.graphType
            }
        };

        this.graph = {
            key:'tpmsrightpanegraph',
            graphType: 'graph',
            position:{ width:6, height:10, left:6, top:0},
            noBroadcast:true,
            graphSetName: 'tpmsRightSideGraph',
            config:[
                {key:'pressure', color: "#5faaff", name:'Pressure'},
                {key:'temp', color: "#ff514f", name:'Temperature'},
                {key:'value', color: "#daff44", name:'Mileage', disabled: true}
            ],
            pointerTime: true,
        }

        this.getMarginTop =()=> {
            let containerHeight = ((window.innerHeight - 50) * 0.7) - 10;
            let widgetHeight = (this.getAxils().length * 65) + 40;
            return (containerHeight - widgetHeight) / 2
        }

    }


    render() {
        return (
            <div className="BridgeStoneTruck">
                <div className={"bst-simButton" + (this.state.simulating ? ' active': '')} onClick={()=>this.toggleSimulation()}>S</div>
                <div className="bst-container">
                    <div className="bstc-body" style={{marginTop:  this.getMarginTop()}}>
                        <div className="bstc-body-inner"></div>
                        {this.getAxils().map((axil, index)=> {
                            return this.getAxil(axil, index);
                        })}
                    </div>
                </div>
                <div className="bst-data">
                    {!this.state.selectedTire ? (
                        <div className="bstd-nodata">Select A Tire</div>
                    ) : null}
                    <div className="bstd-head">
                        <div className="bstdh-name">{this.getSelectedTire().tyreid}</div>
                        {/*<div className="bstdh-data">Ideal PSI : {this.getSelectedTire().idealpsi}</div>*/}
                        {
                            this.historyButtons.map((button, key)=>{
                                return (
                                    <div className={"bstdh-button" + (this.state.selectedHistoryButton.id === button.id ? ' -active': '')}
                                         key={key} onClick={()=>this.getHistory(button)}>{button.name}</div>
                                )
                            })
                        }
                    </div>
                    <div className="bstd-graph">
                        {this.state.historyBusy ? (
                            <div className="bstd-busy">
                                <div className="bstdb-spinner"></div>
                            </div>
                        ) : null}
                        <InGraph data={this.graph} lines={this.graph.config} resume={{}} saveState={()=>{}}
                                 config={this.getGraphConfig(this.graph)} ref={ref=>{this.setRef(this.graph, ref)}}/>
                    </div>
                </div>
            </div>
        )
    }

}
export default BridgeStoneTruck;